export class NewcomerFindPower{
    constructor({el}) {
        this.DOM = {
            cls: el,
            el: $(el)
        }
        if ($(this.DOM.cls).length === 0) {
            return;
        }
        this.init();
    }
    init(){
        $(`${this.DOM.cls} .higher-btn`).on('click',function(){
            $('.find-main-pop').css('display', 'block');
            $('body').css('overflow', 'hidden');
        })
        $('.pop-close-icon').on('click',function(){
            $('.find-main-pop').css('display', 'none');
            $('body').css('overflow', 'auto');
        })
    }
}
